export default __webpack_public_path__ + "static/media/credit-card-1.679638c4.png";